export default "__VITE_ASSET__CRrLGpS6__"